<script lang="ts">
	import "tailwindcss/dist/tailwind.min.css";
	import { default as bodymovin } from "lottie-web";
	import type { AnimationItem } from "lottie-web";
	import { isGzip, lottieResizer } from "./LottieResizer";
	import pako from "pako";
	import { Buffer } from "buffer";
	import type { Animation } from "./LottieParser";

	let fileInput;
	let currentJson: Animation;
	let generatedJson: Animation;
	let requestedData: [number, number];

	$: currentJson;
	$: generatedJson;

	$: requestedData = [320, 320];

	$: currentData = {
		old: [0, 0],
		new: [0, 0],
	};

	let inputPlayer: AnimationItem;
	let outputPlayer: AnimationItem;

	const onFileSelected = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();

		reader.onload = async () => {
			const lottieInputDiv = document.getElementById("lottie-input");
			const lottieOutputDiv = document.getElementById("lottie-output");
			inputPlayer?.destroy();
			lottieInputDiv.innerHTML = "";
			outputPlayer?.destroy();
			lottieOutputDiv.innerHTML = "";
			let result = reader.result as ArrayBuffer;

			const bytes = new Uint8Array(result);

			const fileIsGzip = isGzip(Buffer.from(bytes));

			const json: Animation = fileIsGzip
				? JSON.parse(pako.inflate(bytes, { to: "string" }))
				: JSON.parse(new TextDecoder().decode(bytes));

			currentJson = json;
			currentData.old = [json.w, json.h];

			inputPlayer = bodymovin.loadAnimation({
				container: lottieInputDiv,
				animationData: json,
				renderer: "canvas",
				loop: true,
				autoplay: true,
				name: "Input Animation",
			});

			inputPlayer.play();
		};

		reader.readAsArrayBuffer(file);
	};

	const convert = async () => {
		if (!currentJson) return;
		const lottieOutputDiv = document.getElementById("lottie-output");

		outputPlayer?.destroy();
		lottieOutputDiv.innerHTML = "";

		const newJson = await lottieResizer(
			currentJson,
			requestedData[0],
			requestedData[1]
		);

		generatedJson = newJson;

		currentData.new = [newJson.w, newJson.h];

		console.log(currentData)

		outputPlayer = bodymovin.loadAnimation({
			container: lottieOutputDiv,
			animationData: newJson,
			renderer: "canvas",
			loop: true,
			autoplay: true,
			name: "Output Animation",
		});

		outputPlayer.play();
	};

	const download = () => {
		if (!generatedJson) return;
		const data = `data:application/json,${JSON.stringify(generatedJson)}`;
		let e = document.createElement("a");
		e.style.display = "none";
		e.setAttribute("href", data);
		e.setAttribute("download", "sticker.json");
		document.body.appendChild(e);
		e.click();
		document.body.removeChild(e);
	};
</script>

<main class="m-0 bg-gray-800 w-full h-full min-h-full absolute text-white">
	<div class="container mx-auto max-w-2xl text-center pt-5">
		<h1 class="text-2xl">Lottie Resizer for Discord</h1>
		<p>
			Lottie resolution too big? Shrink it here so you can use it on
			Discord!
		</p>
		<p>When uploading a sticker, it can take some time to appear.</p>
		<p>(oh yeah we also support .tgs files)</p>
		<div class="py-5">
			<input
				type="file"
				accept=".lottie, .tgs, .json"
				on:change={(e) => onFileSelected(e)}
				bind:this={fileInput}
			/>
		</div>
		<div class="grid grid-cols-3 text-black gap-5">
			<input
				type="number"
				placeholder="width"
				class="p-1"
				bind:value={requestedData[0]}
			/>
			<input
				type="number"
				placeholder="height"
				class="p-1"
				bind:value={requestedData[1]}
			/>
			<input type="submit" value="Generate Sticker" on:click={convert} />
		</div>
		<div class="grid grid-cols-1 sm:grid-cols-2">
			<div class="grid grid-cols-1">
				<div id="lottie-input" />
				<span>{currentData.old[0]}x{currentData.old[1]}</span>
			</div>
			<div class="grid grid-cols-1">
				<div id="lottie-output" />
				<span>{currentData.new[0]}x{currentData.new[1]}</span>
			</div>
		</div>
		<button class="bg-gray-900 p-5 rounded-md" on:click={download}>
			Download New Sticker
		</button>
	</div>
</main>

<style>
</style>
